import { Post } from 'components/Post';

const BlogPost = () => <Post />;
export default BlogPost;
